import { useInstallPrompt } from '../../hooks/useInstallPrompt';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Smartphone, Monitor, Download, Share } from 'lucide-react';
import { toast } from 'sonner';

export const InstallAppCard = () => {
  const { isInstallable, isInstalled, isIOS, promptInstall } = useInstallPrompt();

  return (
    <Card className="glass border-white/20 dark:border-white/10">
      <CardHeader>
        <CardTitle className="font-['Manrope'] flex items-center gap-2">
          <Smartphone className="w-5 h-5" /> Install App
        </CardTitle>
        <CardDescription>
          {isInstalled ? "Brioritizer is installed on your device" : "Add Brioritizer to your home screen for quick access"}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {isInstalled ? (
          <div className="flex items-center gap-2 text-emerald-600 dark:text-emerald-400">
            <Monitor className="w-5 h-5" />
            <span className="text-sm font-medium">App is installed</span>
          </div>
        ) : isIOS ? (
          <div className="space-y-3">
            <p className="text-sm text-muted-foreground">To install on your iPhone or iPad:</p>
            <ol className="text-sm text-muted-foreground space-y-2 list-decimal list-inside">
              <li>Tap the <Share className="w-4 h-4 inline mx-1" /> Share button in Safari</li>
              <li>Scroll down and tap <strong>&ldquo;Add to Home Screen&rdquo;</strong></li>
              <li>Tap <strong>&ldquo;Add&rdquo;</strong> in the top right corner</li>
            </ol>
          </div>
        ) : isInstallable ? (
          <Button onClick={async () => { const success = await promptInstall(); if (success) toast.success('App installed successfully!'); }} className="gap-2" data-testid="install-app-btn">
            <Download className="w-4 h-4" /> Install Brioritizer
          </Button>
        ) : (
          <div className="space-y-3">
            <p className="text-sm text-muted-foreground">To add a shortcut to your desktop or home screen:</p>
            <ul className="text-sm text-muted-foreground space-y-2">
              <li><strong>Chrome/Edge:</strong> Click the install icon in the address bar, or use Menu → &ldquo;Install Brioritizer&rdquo;</li>
              <li><strong>Safari (Mac):</strong> File → &ldquo;Add to Dock&rdquo;</li>
              <li><strong>Firefox:</strong> Bookmark this page, then drag it to your desktop</li>
            </ul>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
